import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {Button, Col, Form, FormGroup, Input, Label, Progress} from 'reactstrap';
import Fieldset from './Fieldset';
import OrderRadio from './OrderRadio';
import ReactTelInput from 'react-telephone-input/lib/withStyles';

import lang from '../lang.js';
import helpers, {CUSTOMER_EMAIL} from '../containers/helpers';
import FormDetails from "../containers/FormDetails";

import OrderDetails from './OrderDetails';
import Alert from "./Alert";
import OrdersTable from "./OrdersTable";

class OrderForm extends Component {
    constructor(props) {
        super(props);

        this.lang = lang[props.lang];
        this.langCode = props.lang;
        this.setCred = props.setCred;
        this.setComm = props.setComm;
        this.creds = props.creds;
        this.orders = props.orders;
        this.files = props.files;
        this.comment = props.comment;
        this.addOrder = props.addOrder;
        this.removeOrder = props.removeOrder;

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.isInputValid = this.isInputValid.bind(this);
        this.selectOrder = this.selectOrder.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.appendOrder = this.appendOrder.bind(this);
        this.isOrderAppended = this.isOrderAppended.bind(this);
        this.deleteOrder = this.deleteOrder.bind(this);
        this.toggleAlert = this.toggleAlert.bind(this);
        this.submitFormResult = this.submitFormResult.bind(this);

        this.state = {
            currentOrder: null,
            agreement: false,
            orders: [],
            alert: {isOpen: false},
            progress: 0,
            submit: ''
        };

        Object.keys(this.creds).forEach(cred => this.state[cred] = {value: '', valid: false, onBlur: false});
    }

    componentWillReceiveProps({creds, files, orders, comment}) {
        this.creds = creds;
        this.orders = orders;
        this.files = files;
        this.comment = comment;
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.alert.isOpen)
            window.parent.scrollTo(0, 0);
    }

    componentDidUpdate() {
        if (!this.state.submit.length)
            helpers.updateHeight();
    }

    handleInputChange(e) {
        var target = e.target;
        var isValid = false;
        var found = true;

        if (typeof target === 'undefined')
            return;

        var id = target.id;
        var value = target.value;

        switch (id) {
            case 'firstname':
            case 'lastname':
                value = helpers.capitalize(value);
                this.setState({[id]: Object.assign({}, this.state[id], {value: value})});

                let tmpValue = value.replace(/-/g, '');

                if (this.langCode === "uk")
                    tmpValue = tmpValue.replace(/('|`|‘)/g, '');

                if (!(tmpValue.length < 3)
                    && tmpValue.match(/[^A-Za-zА-Яа-яЁёҐґЄєІіЇї]/g) === null
                    && (value.length - tmpValue.length) <= 2)
                    isValid = true;

                break;

            case 'phone':
                let tel = value.replace(/[^\d]/gi, '');

                if (tel.length > 6 && tel.length < 20)
                    isValid = true;
                break;

            case 'email':
                isValid = helpers.emailValidator(value);
                break;

            case 'comment':
                let apos = this.langCode === "uk" ? "'‘`" : "";
                let regex = new RegExp('[^A-Za-zА-Яа-я-ЁёҐґЄєІіЇї!?.,—()" '+apos+']', 'gi');

                if (value.match(regex) === null && value.length > 4)
                    this.setComm(value);

                found = false;
                break;

            default:
                console.warn(id + ' validator not found');
                found = false;
                break;
        }

        if (found) {
            this.setState({[id]: Object.assign({}, this.state[id], {valid: isValid, value: value})});

            if (isValid)
                this.setCred({[id]: value});

            if (this.state[id].onBlur)
                this.isInputValid(target.tagName, id);
        }
    }

    handleInputKeyDown(e) {
        let apos = this.langCode === "uk" ? "'‘`" : "";
        let regex = e.target.id === 'comment' ?
            new RegExp('[A-Za-zА-Яа-я-ЁёҐґЄєІіЇї!?.,-—()"'+apos+' ]', 'gi') :
            new RegExp('[A-Za-zА-Яа-я-ЁёҐґЄєІіЇї'+apos+']', 'gi');

        if (!helpers.ifkeyCodeAllowed(e, regex))
            e.preventDefault();
    }
    
    handleInputBlur(e) {
        this.setState({[e.target.id]: Object.assign({}, this.state[e.target.id], {onBlur: true})});
    }

    isInputValid(elem, id) {
        if (!this.state[id].onBlur)
            return '';

        let classNames = ['glyphicon-remove', 'glyphicon-ok', 'field-invalid', 'field-valid'];
        let className = '';

        if (elem === 'I') {
            className = 'form-control-feedback glyphicon ';
            className += (!this.state[id].valid ? classNames[0] :classNames[1]);
        } else if (elem === 'INPUT') {
            className += (!this.state[id].valid ? classNames[2] :classNames[3]);
        }

        return className;
    }

    isOrderAppended(id) {
        return this.state.orders.indexOf(id) !== -1;
    }

    selectOrder(e) {
        let orderName = e.target.id;
        let details = this.lang.service.elem[orderName].details;
        let emailDetails = lang.ru.message.email.vashcenter.body.details[orderName];
        this.setState({ currentOrder: orderName }, () => this.state);
        this.addOrder({name: orderName, details: {details: details.root, emailDetails: emailDetails.root}, files: null});
    }

    appendOrder() {
        if (this.state.submit.length)
            return;

        if (this.state.currentOrder === null) {
            this.setState({alert: {isOpen: true, header: this.lang.message.attention, body: [this.lang.message.choose_an_order]}});
            return;
        }

        this.setState({currentOrder: null, orders: [...this.state.orders, this.state.currentOrder]});
    }

    async deleteOrder(e) {
        let orderName = e.target.dataset.ordername;
        let orderObj = this.orders.filter(order => order.name === orderName).pop();
        let newState = {};

        if (this.state.orders.indexOf(orderName) !== -1) {
            let orders = this.state.orders;
            orders.splice(orders.indexOf(orderName), 1);
            newState.orders = [...orders];
        }

        if (this.state.currentOrder === orderName)
            newState.currentOrder = null;

        this.setState(newState);

        if (orderObj.files !== null && typeof orderObj.files !== 'undefined')
            await helpers.removeFromAllFiles(this.files, orderObj.files.zip);

        this.removeOrder(orderName);

        document.querySelector('#'+orderName).checked = false;

        typeof OrderDetails.ordersToReset !== 'undefined' ?
            OrderDetails.ordersToReset.push(orderName) :
            OrderDetails.ordersToReset = [orderName];
    }

    toggleAlert() {
        this.setState({alert: {isOpen: !this.state.alert.isOpen}});
    }

    async submitForm(e) {
        e.preventDefault();

        if (this.state.submit.length)
            return;

        let isInputValid = this.state.firstname.valid && this.state.lastname.valid && this.state.phone.valid && this.state.email.valid;
        let areOrdersAdded = this.orders.length > 0;
        let isAgreeAccepted = this.state.agreement;
        let allValid = (isInputValid && areOrdersAdded && isAgreeAccepted);

        if (!allValid) {
            let errs = [];

            if (!isInputValid)
                errs.push(this.lang.message.contacts_wrong);

            if (!areOrdersAdded)
                errs.push(this.lang.message.no_order_chosen);

            if (!isAgreeAccepted)
                errs.push(this.lang.message.agreement_unaccepted);

            this.setState({alert: {isOpen: true, header: this.lang.message.attention, body: errs}});

            return;
        }

        e.target.classList.toggle('submitted');
        helpers.updateHeight();
        window.parent.scrollTo(0, 0);

        let data = {
            creds: this.creds,
            orders: this.orders,
            files: this.files,
            comment: this.comment
        };

        let email = await helpers.cookEmail(this.langCode, 'vashcenter', data);
        let vcappObj = helpers.cook4VCApp(data);
        let formData = new FormData();
        let customerId = null;
        let emailSent = false;

        if (vcappObj.docType.length && vcappObj.orderCategory.length) {
            let attachment = email.attachment;
            delete email.attachment;

            formData.append('target', 'NEW_RECORD_WEBSITE');
            formData.append('pid_docs', attachment, 'docs');
            formData.append('json', helpers.encrypt(JSON.stringify(vcappObj)));
            formData.append('email', helpers.encrypt(JSON.stringify(email)));

            try {
                let respJson = await helpers.ajax('/record', formData, progress => {
                    this.setState({progress: progress});
                });

                let respObj = JSON.parse(respJson);

                if ('customerId' in respObj)
                    customerId = respObj.customerId;

                if (respObj.result === 'emailSent')
                    emailSent = true;

            } catch(err) {
                console.error(err);
            }
        } else {
            customerId = Date.now();
            email.body = email.body.replace(/\$ID/g, customerId);

            formData.append('recipients', CUSTOMER_EMAIL);
            formData.append('subject', helpers.encrypt(email.subject));
            formData.append('message', helpers.encrypt(email.body));

            try {
                await helpers.ajax('/mailer', formData, progress => {
                    this.setState({progress: progress});

                    if (progress === 100)
                        emailSent = true;
                });

            } catch(err) {
                emailSent = false;
                console.error(err);
            }
        }

        data.orderId = customerId !== null ? customerId : Date.now();

        email = await helpers.cookEmail(this.langCode, 'customer', data);

        formData = new FormData();
        formData.append('recipients', helpers.encrypt(this.creds.email));
        formData.append('subject', helpers.encrypt(email.subject));
        formData.append('message', helpers.encrypt(email.body));

        helpers.ajax('/mailer', formData).catch(err => console.error(err));

        this.setState({submit: emailSent ? 'ok' : 'no'});
    }

    submitFormResult(target) {
        let result = {
            class: this.state.submit === 'ok' ? 'alert-success' :
                this.state.submit === '' ? 'alert-light' : 'alert-danger',

            html: this.state.submit === 'ok' ? this.lang.message.order_submitted :
                this.state.submit === '' ? this.lang.message.processing : this.lang.message.order_submit_err
        };

        return result[target];
    }

    render() {
        const langContact = this.lang.contact;
        const langService = this.lang.service;
        const langOrdered = this.lang.serviceOrdered;
        const orders = Object.entries(langService.elem);

        return (
            <Form onSubmit={this.submitForm}>
                <Fieldset className="fieldset-group" legend={langContact.legend}>
                    <FormGroup row>
                        <Col xs="6" md="6">
                            <Label for="firstname">{langContact.elem.firstname.label}</Label>
                            <Input type="text" name="firstname" id="firstname" className={this.isInputValid('INPUT', 'firstname')} placeholder={langContact.elem.firstname.placeholder}
                                   onKeyDown={this.handleInputKeyDown} onChange={this.handleInputChange} onKeyUp={this.handleKeyUp} onBlur={this.handleInputBlur}
                                   maxLength="35" autoComplete="off" autoCorrect="off" spellCheck="false" value={this.state.firstname.value} />
                            <i className={this.isInputValid('I', 'firstname')}></i>
                        </Col>
                        <Col xs="6" md="6">
                            <Label for="lastname">{langContact.elem.lastname.label}</Label>
                            <Input type="text" name="lastname" id="lastname" className={this.isInputValid('INPUT', 'lastname')} placeholder={langContact.elem.lastname.placeholder}
                                   onKeyDown={this.handleInputKeyDown} onChange={this.handleInputChange} onBlur={this.handleInputBlur}
                                   maxLength="35" autoComplete="off" autoCorrect="off" spellCheck="false" value={this.state.lastname.value} />
                            <i className={this.isInputValid('I', 'lastname')}></i>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col xs="6" md="6">
                            <Label for="phone">{langContact.elem.phone.label}</Label>
                            <ReactTelInput id="phone" maxlength="20" defaultCountry="gr" preferredCountries={['ua', 'ru', 'by', 'bg', 'md', 'al']} flagsImagePath='images/flags.png'
                                           classNames={this.isInputValid('INPUT', 'phone')} onChange={this.handleInputChange} onBlur={this.handleInputBlur} />
                            <i className={this.isInputValid('I', 'phone')}></i>
                        </Col>
                        <Col xs="6" md="6">
                            <Label for="email">{langContact.elem.email.label}</Label>
                            <Input type="email" name="email" id="email" className={this.isInputValid('INPUT', 'email')} placeholder={langContact.elem.email.placeholder}
                                   onChange={this.handleInputChange} onBlur={this.handleInputBlur}
                                   maxLength="50" autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" />
                            <i className={this.isInputValid('I', 'email')}></i>
                        </Col>
                    </FormGroup>
                </Fieldset>

                <Fieldset className="fieldset-group" legend={langService.legend}>
                    <Label className="label-service">{langService.labelOpt}</Label>

                    <FormGroup className="services-group" row>
                        {orders.map((order, i) => {
                            return (
                                <Col key={i} xs="6" md="4">
                                    <OrderRadio key={order[0]} isOrderAppended={this.isOrderAppended} selectOrder={this.selectOrder} label={order[1].label} id={order[0]} />
                                </Col>
                            )
                        })}
                    </FormGroup>

                    <FormDetails lang={this.lang} langCode={this.langCode} order={this.state.currentOrder} />

                    <FormGroup row>
                        <Button id="addServiceBtn" className="btn add-service" color={""} onClick={this.appendOrder}>
                            <i className="glyphicon glyphicon-plus" aria-hidden="true"></i>{' '}{langService.addOrderBtn}
                        </Button>
                    </FormGroup>
                </Fieldset>

                <Fieldset className="fieldset-group" legend={langOrdered.legend}>
                    <OrdersTable lang={this.lang} onOrderRemove={this.deleteOrder} />

                    <FormGroup>
                        <Label for="comment" className="label-service optional">{langOrdered.comment}</Label>
                        <Input type="textarea" name="comment" id="comment" maxLength={255} spellCheck={false}
                               onChange={this.handleInputChange} onKeyDown={this.handleInputKeyDown} />
                    </FormGroup>

                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" name="agreement" id="agreement" onChange={() => this.setState({'agreement': true})} />{langOrdered.agreement}{' '}
                            <a style={{fontSize: 'small'}} href="/wp-content/uploads/docs/legal.pdf" target="_blank">doc <i style={{fontSize: 'smaller'}} className="glyphicon glyphicon-new-window" aria-hidden="true"></i></a>
                        </Label>
                    </FormGroup>

                    <FormGroup row>
                        <Button type="submit" id="submitBtn" className="btn submit-orders" color={""}>
                            <i className="glyphicon glyphicon-send" aria-hidden="true"></i>{' '}{langOrdered.submitBtn}
                        </Button>
                    </FormGroup>

                    <FormGroup hidden={true}>
                        <Progress value={this.state.progress} />
                        <div className={"alert " + this.submitFormResult('class')} dangerouslySetInnerHTML={{__html: this.submitFormResult('html')}} role="alert" />
                    </FormGroup>
                </Fieldset>

                <Alert {...this.state.alert} toggleAlert={this.toggleAlert} />
            </Form>
        );
    }
}

OrderForm.propTypes = {
    lang: PropTypes.string.isRequired,
    setCred: PropTypes.func.isRequired,
    addOrder: PropTypes.func.isRequired,
    creds: PropTypes.shape({
        firstname: PropTypes.string,
        lastname: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string
    }),
    orders: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        details: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string
        ]),
        deadline: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string
        ]),
        files: PropTypes.shape({
            count: PropTypes.number,
            size: PropTypes.number,
            zip: PropTypes.instanceOf(Blob),
        })
    })),
    comment: PropTypes.string
};

OrderForm.defaultProps = {
    lang: 'ru'
};

export default OrderForm;


// WEBPACK FOOTER //
// ./src/app/components/OrderForm.js